export enum ANALYTICS_EVENTS {
  SCREEN = 'SCREEN',
  ACTION = 'ACTION',
}

export type AnalyticsData = {
  type: ANALYTICS_EVENTS
  value: string
  screen?: string
  component?: string
  label?: string
  customPayload?: Record<string, unknown> | null
}

/** Values of the `fx_action` platform key: the gesture behind a component event. */
export enum ComponentAnalyticsAction {
  COPY = 'COPY',
  FEEDBACK = 'FEEDBACK',
  UNSET_FEEDBACK = 'UNSET_FEEDBACK',
  OPEN = 'OPEN',
  OPEN_TASK = 'OPEN_TASK',
  FILTER = 'FILTER',
  SORT = 'SORT',
  PAGE = 'PAGE',
  DELETE_ROW = 'DELETE_ROW',
  EDIT_ROW = 'EDIT_ROW',
  SEARCH = 'SEARCH',
  TASK_ACTION = 'TASK_ACTION',
  CHANGE_PRIORITY = 'CHANGE_PRIORITY',
}

/** Values of the `fx_outcome` platform key, sent by upload, download and document preview. */
export enum AnalyticsOutcome {
  REJECTED = 'REJECTED',
  SUCCEEDED = 'SUCCEEDED',
  OPENED = 'OPENED',
  LOADED = 'LOADED',
  FAILED = 'FAILED',
}

/** Values of the `fx_sort_direction` platform key. `NONE` is a removed sort. */
export enum AnalyticsSortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
  NONE = 'NONE',
}

/** Values of the `fx_display_mode` platform key of a document preview. */
export enum AnalyticsDisplayMode {
  INLINE = 'INLINE',
  ACCORDION = 'ACCORDION',
  MODAL = 'MODAL',
}

/**
 * Values of the `fx_error` platform key of an upload. A failed request sends its HTTP status
 * instead, except a UI flow upload that fails through SSE and a request with no readable response.
 */
export enum AnalyticsUploadError {
  FILE_SIZE_EXCEEDED = 'FILE_SIZE_EXCEEDED',
  INVALID_FILE_TYPE = 'INVALID_FILE_TYPE',
  TOTAL_SIZE_EXCEEDED = 'TOTAL_SIZE_EXCEEDED',
  MAX_FILES_EXCEEDED = 'MAX_FILES_EXCEEDED',
  PROCESSING_FAILED = 'PROCESSING_FAILED',
  NETWORK_ERROR = 'NETWORK_ERROR',
}
